import { gql } from 'graphql-tag';

export const GET_LEARNING_PATHS_BY_COURSE_SLUG = gql`
  query getLearningPathsByCourseSlug($slug: String!, $preview: Boolean!) {
    learningPathCollection(preview: $preview, where: { courses: { slug: $slug } }) {
      items {
        __typename
        sys {
          id
        }
        title
        slug
      }
    }
  }
`;

export type GetLearningPathsByCourseSlugQuery = {
  learningPathCollection: {
    items: Array<{
      __typename: string;
      sys: {
        id: string;
      };
      title: string;
      slug: string;
    }>;
  };
};

export type GetLearningPathsByCourseSlugQueryVariables = {
  slug: string;
  preview: boolean;
};

export type ContentfulLearningPathBasic = GetLearningPathsByCourseSlugQuery['learningPathCollection']['items'];
